import React from 'react'

import { LntCarousel } from '@app/components/base'
import { ImageRenderer } from '@app/components/renderers'

import styles from './styles.module.scss'

import type { ImageSlideProps } from './types'

const INITIAL_HEIGHT = '600'

export const ImageSlider: React.FC<ImageSlideProps> = ({
  images = [],
  height = INITIAL_HEIGHT,
  fallbackContent,
  ...restProps
}) => {
  const imagesSlider = (
    <LntCarousel { ...restProps }>
      { images.map((image, index) => (
        <div key={ `${index}_${image.src ?? ''}` }>
          <div
            className={ styles.imageSlider__container }
            style={ { height: `${height}px` } }
          >
            <ImageRenderer
              { ...image }
              fallbackContent={ fallbackContent }
              style={ { maxHeight: `${height}px` } }
            />
          </div>
        </div>
      )) }
    </LntCarousel>
  )

  return (
    <div
      className={ styles.imageSlider__container }
      style={ { height: `${height}px` } }
    >
      { images.length ? imagesSlider : <span>Изображений не найдено</span> }
    </div>
  )
}
